<template>
    <!-- Note: Outer div required to be used with q-col responsive classes! -->
    <div>
        <q-card class="kpi-card">
            <q-card-section
                class="q-pa-none dashboard-card--header justify-between"
            >
                <p>{{ title }}</p>
                <p
                    v-if="comparisonValue"
                    :class="{
                        'kpi-card__low': difference < 0,
                        'kpi-card__neutral': difference == 0,
                        'kpi-card__high': difference > 0
                    }"
                >
                    {{ difference != 0 ? (difference > 0 ? '▲' : '▼') : '-' }}
                    {{ formatPercent(difference / 100) }}
                </p>
            </q-card-section>
            <q-card-section
                :class="{
                    'kpi-card__low': value < 0.5,
                    'kpi-card__medium': value >= 0.5 && value <= 0.75,
                    'kpi-card__high': value > 0.75
                }"
                class="text-center q-pa-none kpi-card--body"
            >
                {{ formatPercent(value) }}
            </q-card-section>
        </q-card>
    </div>
</template>

<script>
export default {
    name: 'KPICard',
    methods: {
        /**
         * Format decimal number to percent.
         * @param {Number}
         * @return {String}
         */
        formatPercent(val) {
            return (val * 100).toFixed(2) + '%';
        }
    },
    computed: {
        difference() {
            const percentage =
                (this.value - this.comparisonValue) / this.comparisonValue;
            return (percentage * 100).toFixed(2);
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: Number,
            required: true
        },
        comparisonValue: {
            type: Number,
            required: false
        }
    }
};
</script>

<style lang="scss" scoped>
@import './dashboard.scss';
.kpi-card {
    overflow: hidden;
}

.kpi-card--body {
    font-size: 50px;
    font-weight: 700;
}

.kpi-card__low {
    color: $light-red;
}

.kpi-card__medium {
    color: $warning;
}

.kpi-card__high {
    color: $light-green;
}

.kpi-card__neutral {
    color: $medium-grey;
}
</style>
